import {Navigate, Outlet, useLocation} from 'react-router';
import {useAtomValue} from 'jotai';
import {authStatusAtom} from '@/state/authAtoms';
import {Box, CircularProgress} from '@mui/material';
import {routerLinks} from '@/Constants.ts';

/**
 * Allows through both 'authenticated' and 'offline-cached' users —
 * a field user with no signal but a valid cached session should
 * still reach the app, just potentially with reduced write access
 * (enforce that at the mutation level, not here).
 */
export function RequireAuth() {
   const status = useAtomValue(authStatusAtom);
   const location = useLocation();

   if (status === 'loading') {
      return (
         <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
            <CircularProgress />
         </Box>
      );
   }

   if (status === 'unauthenticated') {
      return <Navigate to={routerLinks.login} state={{from: location}} replace />;
   }

   return <Outlet />;
}
